<nav class="layout-breadcrumb">
  <ol>
    @for (item of breadcrumbs$ | async; track $index; let last = $last) {
      <li>
        @if (!last) {
          <a [routerLink]="[item.url]" class="layout-breadcrumb__link">
            {{ item.label }}
          </a>
        }
        @if (!last) {
          <li class="layout-breadcrumb-chevron">/</li>
        } @else {
          {{ item.label }}
        }
      </li>
    }
  </ol>
</nav>
